module.exports = __webpack_public_path__ + "img/elvis.f3535baf.jpeg";